import React, { useState, useEffect } from 'react';
import { Box, Typography, Grid } from '@mui/material';
import TeamIosDarkToggle from 'team/shared/components/button/TeamIosDarkToggle';

const TeamTemplateSettingsContainer = ({ template, onTemplateUpdate, isCreating, onSave, onCancel, isSubmitting }) => {
    // State for allow non-admins toggle
    const [allowNonAdminsToAssign, setAllowNonAdminsToAssign] = useState(
        template?.settings?.allowNonAdminsToAssign || false
    );

    // Update local state when template changes
    useEffect(() => {
        setAllowNonAdminsToAssign(template?.settings?.allowNonAdminsToAssign || false);
    }, [template]);

    // Handle toggle change
    const handleAllowNonAdminsToggle = (event) => {
        const isChecked = event.target.checked;
        setAllowNonAdminsToAssign(isChecked);
        
        // Update template immediately
        if (onTemplateUpdate) {
            onTemplateUpdate('settings', {
                allowNonAdminsToAssign: isChecked
            });
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                overflow: 'hidden',
                position: 'relative'
            }}
        >
            {/* Header */}
            <Box
                sx={{
                    padding: 2,
                    paddingBottom: 0,
                    backgroundColor: 'white',
                    flexShrink: 0
                }}
            >
                <Typography
                    variant="h6"
                    component="h2"
                    sx={{
                        fontSize: '1rem',
                        fontWeight: 'normal',
                        marginBottom: 2
                    }}
                >
                    Template Settings
                </Typography>
            </Box>

            {/* Content */}
            <Box
                sx={{
                    flex: 1,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    backgroundColor: 'white'
                }}
            >
                <Box sx={{ padding: 2 }}>
                    <Box
                        sx={{
                            backgroundColor: '#f7f7f7',
                            padding: 2,
                            borderRadius: '12px'
                        }}
                    >
                        <Grid container alignItems="center" spacing={2}>
                            <Grid item xs={12} sm={8}>
                                <Typography
                                    variant="body1"
                                    sx={{
                                        fontSize: '0.8rem',
                                        fontWeight: 600,
                                        color: "#000000"
                                    }}
                                >
                                    Allow non-admins to assign this template to their cards
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontSize: '0.75rem',
                                        color: "#848282",
                                        marginTop: 1
                                    }}
                                >
                                    When enabled, it is recommended that all unique links on this template are unlocked.
                                </Typography>
                            </Grid>

                            <Grid
                                item
                                xs={12}
                                sm={4}
                                display="flex"
                                justifyContent={{ xs: 'flex-start', sm: 'flex-end' }}
                            >
                                <TeamIosDarkToggle
                                    checked={Boolean(allowNonAdminsToAssign)}
                                    onChange={handleAllowNonAdminsToggle}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default TeamTemplateSettingsContainer;

